<template>
  <div class="search-view">
    <div class="left">
      <img :src="logo" alt="" @click="goHome">
    </div>
    <div class="middle">
      <div class="middle-content">
        <input type="text" v-model="searchVal">
        <button @click="searchClick">搜索</button>
      </div>
      <div class="middle-content">
        热搜：
        <ul>
          <li v-for="(item,index) in HotSearchList" :key="index" @click="hotClick(item.text)">{{item.text}}</li>
        </ul>
      </div>
    </div>
    <div class="right">
      <el-badge class="item" :value="shoppingNum">
        <el-button plain icon="el-icon-goods" @click="goShoppingCart">购物车</el-button>
      </el-badge>
    </div>
  </div>
</template>
<script>
export default {
  name: '',
  data () {
    return {
      logo: require('@/assets/images/login/logo.png'),
      searchVal: '',
      HotSearchList: [],
      shoppingNum: 0
    }
  },
  methods: {
    hotClick (text) {
      this.searchVal = text
      this.$router.push({
        path: '/home/search',
        query: {
          text: text
        }
      })
    },
    searchClick () {
      if (this.searchVal) {
        this.$router.push({
          path: '/home/search',
          query: {
            text: this.searchVal
          }
        })
      }
    },
    goShoppingCart () {
      const userId = this.$store.state.userMsg.id
      if (!userId) {
        this.$router.push({
          name: 'Login'
        })
      } else {
        this.$router.push({
          name: 'ShoppingCart'
        })
      }
    },
    getHotWords () { // 获取热搜
      this.$get(this.$allUrl.getHotWords).then(res => {
        if (res.code === '0') {
          const list = res.data
          list.forEach((e, i) => {
            if (i === 0) {
              this.searchVal = e.word
            }
            this.HotSearchList.push({
              text: e.word,
              id: e.id
            })
          })
        }
      })
    },
    goHome () { // 跳转到首页
      this.$router.push({
        name: 'Home'
      })
    },
    getShoppingNum () {
      const userId = this.$store.state.userMsg.id
      if (userId) {
        this.$get(this.$allUrl.getCartNum + `?userId=${userId}`).then(res => {
          if (res.code === '0') {
            this.shoppingNum = res.data
          }
        })
      }
    }
  },
  mounted () {
    this.getHotWords()
    this.getShoppingNum()
    // 发射更新购物车数量的方法
    this.$root.eventHub.$on('update_shoppingNum', () => {
      this.getShoppingNum()
    })
  }
}
</script>
<style lang="less" scoped>
  .search-view{
    display: flex;
    padding: 30px 30px 0 20px;
    .left{
      padding-left: 30px;
      img{
        width: 150px;
        cursor: pointer;
      }
    }
    .middle{
      flex: 1;
      .middle-content{
        margin:auto;
        width: 500px;
        display: flex;
        font-size: 12px;
        color: #B7151E;
        input{
          flex: 1;
          border: 2px solid #B7151E;
          padding: 10px;
          outline: none;
          -webkit-tap-highlight-color: rgba(0,0,0,0);
        }
        button{
          background-color: #B7151E;
          border: 0;
          outline: none;
          cursor: pointer;
          color: white;
          padding: 0 20px;
        }
        ul{
          list-style: none;
          display: flex;
          margin: 0;
          padding: 0;
          li{
            padding: 0 5px;
            cursor: pointer;
            color: #666666;
          }
          li:hover{
            color: #B7151E;
          }
        }
      }
      .middle-content:last-child{
        padding-top: 10px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/base/search/search.vue